import React, {Component, PropTypes} from 'react';

import NotificationSystem from 'react-notification-system';


class Notifications extends Component {
    constructor(props) {
        super(props);

        this._notificationSystem = null;
        this._handledNotifications = {};
    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;

        this.syncNotifications(this.props);
    }

    componentWillReceiveProps(nextprops) {
        this.syncNotifications(nextprops);
    }

    addNotification(cfg) {
        if (cfg.loader) {
            cfg.message = (
                <span>
                    {cfg.message}
                    <div className="loading-bar"><div></div></div>
                </span>
            );
        }

        if (this._notificationSystem) {
            this._notificationSystem.addNotification(cfg);
        }
    }

    syncNotifications(props) {
        const add = [];
        const seen = [];

        Object.keys(props.notificationStore.notifications).forEach(uuid => {
            if (!this._handledNotifications[uuid]) {
                // Add a new one
                this.addNotification(props.notificationStore.notifications[uuid]);

                // Push to added list
                add.push(uuid);

            } else {
                // Push to seen list
                seen.push(uuid);
            }
        });

        // Remove all old ones
        Object.keys(this._handledNotifications).forEach(uuid => {
            if (add.indexOf(uuid) === -1 && seen.indexOf(uuid) === -1) {
                if (this._notificationSystem) {
                    this._notificationSystem.removeNotification(this._handledNotifications[uuid]);
                }
                delete this._handledNotifications[uuid];
            }
        });

        // Store ref to active notifications
        add.forEach(uuid => {
            this._handledNotifications[uuid] = props.notificationStore.notifications[uuid];
        });
    }

    render() {
        return (
            <div style={{zIndex: 999999999}}>
                <NotificationSystem ref="notificationSystem" />
            </div>
        );
    }
}

Notifications.propTypes = {
    notificationStore: PropTypes.object.isRequired
};

export default Notifications;



/** WEBPACK FOOTER **
 ** ./app/src/components/Notifications.js
 **/